/**
 * Дельта серверного времени относительно локальных часов (секунды).
 * Обновляется при каждом успешном refresh / obtain-tokens.
 */
let clockDeltaSeconds = 0;

export function updateClockDeltaFromServer(serverTimestampSeconds) {
  clockDeltaSeconds =
    serverTimestampSeconds - Math.floor(Date.now() / 1000);
}

export function getClockDeltaSeconds() {
  return clockDeltaSeconds;
}
